<template>
  <div class="header-div">
    <div class="header-title">{{titleName}}</div>
    <div class="header-condition" v-show="isShowSearch">
      <el-input v-if="type == 'input'" size="mini" placeholder="输入关键字搜索" v-on:keyup.enter.native="submit();" v-model="inputValue"/>
      <el-select v-if="type == 'select'"  placeholder="请选择" v-model="selectValue" @change="submit();">
        <el-option  v-for="item in dataList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
    export default {
        name: "XrHeaderSearch",
        props:{
          type: String,                       //类型  input
          titleName: String,                 //表头名称
          isShowSearch: Boolean,             //表头名称
          searchList: Array                  //查询的list
        },
        data() {
          return {
            inputValue: '',
            selectValue: '',
            dataList: []
          }
        },
        created() {
          this.dataList.push({value: '',label: ''});
          let list = this.searchList;

         if(list && list.length > 0){
           list.forEach(element => {
             this.dataList.push(element);
           });
         }
        },
        methods: {
          submit(){
            let value = '';
            if(this.type == 'input'){
              value = this.inputValue;
            }else if(this.type == 'select'){
              value = this.selectValue;
            }
            this.$emit('searchClick',value)
          },
          //清空内容接口
          clearContent(){
            if(this.type == 'input'){
              this.inputValue = '';
            }else if(this.type == 'select'){
              this.selectValue = '';
            }
          }
        }

    }
</script>

<style scoped>




</style>



// WEBPACK FOOTER //
// src/components/XrHeaderSearch/index.vue